export const EditCommentDialogTranslations = {
  commentPlaceholder: 'Comment...',

  apply: 'jbp-planning-comment-apply',
  cancel: 'jbp-planning-comment-cancel',
}

export default EditCommentDialogTranslations
